var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContentHold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.2 0 16 4.8v6.4L11.2 16H4.8L0 11.2V4.8L4.8 0zm-.8 2H5.6L2 5.6v4.8L5.6 14h4.8l3.6-3.6V5.6zM10 3l3 3v4l-3 3H6l-3-3V6l3-3z"
})));
export default SvgContentHold;